import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { compactNumber } from "../../screens/dashboard/DashboardCard";

const BarChart = ({ value, userCurrency }) => {
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  console.log(userCurrency);
  let dataLabel = value[2].map((item) => item.slice(0, 3));
  const isMobile = window.innerWidth <= 568;
  let dataValueOnline = value[0];
  let dataValueOffline = value[1];

  const options = {
    aspectRatio: 1.6,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 16,
        },
      },
      title: {
        display: true,
        text: "Amount of Product Sold",
      },
      tooltip: {
        callbacks: {
          // show full value in tooltip (not compact)
          label: (ctx) => `${ctx.dataset.label.trim()}: ${compactNumber(ctx.parsed.y)}`,
        },
      },
    },
    scales: {
      y: {
        ticks: {
          // compact labels on the axis
          callback: (value) => compactNumber(value),
          stepSize: 100000 /* make it responsive */,
        },
        title: {
          display: isMobile ? false : true,
          text: "Sales (in " + userCurrency + ")",
        },
        grid: {
          display: true,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    barThickness: 6,
    borderRadius: 6,
  };

  const labels = dataLabel;

  const data = {
    labels,
    datasets: [
      {
        label: "online sales",
        data: dataValueOnline,
        backgroundColor: "#3768C1",
      },
      {
        label: "in-store sales",
        data: dataValueOffline,
        backgroundColor: "#A8AFEB",
      },
    ],
  };

  return (
    <>
      <Bar data={data} options={options} />
    </>
  );
};

export default BarChart;
